var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParliamentPerson = function SvgParliamentPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "parliament-person_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".parliament-person_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12.5h3c.6 0 1 .4 1 1V20c0 .3-.2.5-.5.5h-3.5M4.5 20.5H1c-.3 0-.5-.2-.5-.5v-6.5c0-.6.4-1 1-1h3M19.5 23c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V12.5l7.1-2.9c.2-.1.5-.1.7 0l7.1 2.9V23z",
    className: "parliament-person_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.1V8.5h13v3.6M5.5 8.5C5.5 4.9 8.4 2 12 2s6.5 2.9 6.5 6.5M12 2V.5M7.5 21.5v-7M10.5 21.5v-7M13.5 21.5v-7M16.5 21.5v-7M4.5 14.5h15M4.5 21.5h15",
    className: "parliament-person_svg__st0"
  })));
};
export default SvgParliamentPerson;